export default (id) =>
  new Promise((resolve, reject) => {
    window.axios
      .delete(`${process.env.VUE_APP_API_ADMIN_LOCATION}prescription-discounts/${id}`)
      .then(({ data }) => {
        resolve(data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
